<template>
  <div id="background-canvas" :style="{top:top }">
    <particle v-for="n in 40"/>
  </div>
</template>

<script>
  import Particle from "./Particle";

  export default {
    components: {Particle},
    data() {
      return {
        scroll:0,
        top:'0px'
      }
    },
    name: "background",
    mounted() {

      // this.scrollTop = window.pageYOffset;
      // this.offset = 0;
      //
      // const scroller = () => {
      //   this.scroll = this.scrollTop - window.pageYOffset;
      //   this.top = (this.offset += this.scroll * 0.2) + 'px';
      //   this.scrollTop = window.pageYOffset;
      //   this.rafId = requestAnimationFrame(scroller);
      // };
      //
      // this.rafId = requestAnimationFrame(scroller);
      // scroller();

    },
    destroyed() {
      cancelAnimationFrame(this.rafId);
    }
  }
</script>

<style>
  #background-canvas {
    z-index: -2;
    position: fixed;
    width: 100%;
    height: 200%;
    margin: 0;
    top:0;
    left:0;
    overflow: hidden;
    /*background-color: yellow;*/
    /*background-color: transparent;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/Background.vue